import ConfirmationModal from 'components/modals/confirmation/ConfirmationModal';
import { useModal } from 'components/modals/useModal';
import { useDeleteProjectMutation } from 'store/api/projects';
import { t } from 'utils/getTranslations';
import { logError } from 'utils/monitoring';
import { useLeaveDeletedEntity } from 'utils/useNavigateWithReturnState';

/**
 * Delete, for the edit form and the record header: asks first, then leaves the project's pages.
 * `beforeLeave` runs once the project is gone, such as lifting the form's leave guard.
 */
export const useProjectDelete = (projectId: string | undefined, beforeLeave?: () => void) => {
    const { openModal, closeModal } = useModal();
    const leaveDeleted = useLeaveDeletedEntity('/projects');
    const [deleteProject] = useDeleteProjectMutation();

    return () => {
        if (projectId && !isNaN(Number(projectId))) {
            openModal(
                <ConfirmationModal
                    onCancel={closeModal}
                    onConfirm={() => {
                        void (async () => {
                            try {
                                await deleteProject({ id: projectId }).unwrap();
                                closeModal();
                                beforeLeave?.();
                                leaveDeleted();
                            } catch (e) {
                                console.error(e);
                                logError(e);
                            }
                        })();
                    }}
                    content={<p className="text-body1">{t('projects.delete-confirmation-text')}</p>}
                />
            );
        }
    };
};
